import React from 'react'
import ListHeader from '../shared/ListHeader/ListHeader'
import { BackButton, baseUrl } from './Examples'

const ExampleListHeader = (): JSX.Element => {
    return (
        <div style={{ top: 100, position: 'relative' }}>
            <div>
                <h2>Component ListHeader, exemplo 1:</h2>
                <BackButton href={baseUrl} />

                <ListHeader
                    title={'Example 1'}
                    total={10}
                    icon={'fas fa-file-chart-pie'}
                    showStatus={true}
                    // titleStatus={'Active'}
                    status={[]}
                    // titleStatus2={'Monitoring'}
                    status2={[]}
                />

                <h2>Component ListHeader, exemplo 2:</h2>
                <ListHeader
                    title={'Example 2'}
                    total={10}
                    icon={'fas fa-file-chart-pie'}
                    showStatus={true}
                    titleStatus={'Active'}
                    status={[]}
                    titleStatus2={'Monitoring'}
                    status2={[]}
                />

                <h2>Component ListHeader, exemplo 3:</h2>
                <ListHeader
                    title={'Example 3'}
                    total={10}
                    icon={'fas fa-file-chart-pie'}
                    showStatus={true}
                    titleStatus={'Active'}
                    status={[
                        {
                            id: 123,
                            icon: 'far fa-map-marked-alt',
                            color: 'blue',
                            title: 'Maps',
                            subtitle: 'Location',
                            subtitle2: 'Coordinates',
                            background: 'yellow'
                        }
                    ]}
                    // titleStatus2={}
                    status2={[]}
                />

                <h2>Component ListHeader, exemplo 4:</h2>
                <ListHeader
                    title={'Example 4'}
                    total={10}
                    icon={'fas fa-file-chart-pie'}
                    showStatus={true}
                    titleStatus={'Active'}
                    status={[
                        {
                            id: 123,
                            icon: 'far fa-map-marked-alt',
                            color: 'blue',
                            title: 'Maps',
                            subtitle: 'Location',
                            subtitle2: 'Coordinates',
                            background: 'yellow'
                        }
                    ]}
                    titleStatus2={'Monitoring'}
                    status2={[
                        {
                            id: 123,
                            icon: 'far fa-map-marked-alt',
                            color: 'blue',
                            title: 'Maps',
                            subtitle: 'Location',
                            subtitle2: 'Coordinates',
                            background: 'yellow'
                        }
                    ]}
                />
            </div>
        </div>
    )
}

export default ExampleListHeader
